import { configureStore } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
import { webAuth } from './reducers/auth0';
export const store = configureStore({
  reducer: {
    counter: counterReducer,
    auth0: webAuth,
  },
});
